import React from "react";
import { useLocation } from "react-router-dom";
import modsfactoryUrls from "../../../../configs/mods_factory/modsfactoryUrls";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo from "../../../../componets/NavBarTwo";

const _PageHeader: React.FC = () => {
  const ITEMS: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Trending',
      url: modsfactoryUrls.addonsTrendingPath()
    },
    2: {
      id: 2,
      name: 'Popular',
      url: modsfactoryUrls.addonsPopularPath()
    },
    3: {
      id: 3,
      name: 'Recents',
      url: modsfactoryUrls.addonsRecentsPath()
    }
  };

  const { pathname } = useLocation();
  const activeItem = Object.values(ITEMS).find(e => e.url === pathname);

  return (
    <PageHeader
      title={'Community'}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={ITEMS}
        itemIds={Object.keys(ITEMS)}
        parent={{
          name: 'All',
          url: modsfactoryUrls.addonsPath()
        }}
        activeId={activeItem?.id}
      />
    </PageHeader>
  );
}

export default _PageHeader;
